import React, { useCallback } from 'react';
import { isQuestionCategoryVisible } from '../../../../../data/filters/questions/isQuestionCategoryVisible';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import Tab from '../../../../elements/Tabs/Tab';
import Tabs from '../../../../elements/Tabs/Tabs';

const VISIBLE_TABS = 3;

/**
 * Renders a set of tab buttons for navigating between different question categories.
 *
 * @param {Object} props - The props for the component.
 * @param {Object} props.event - The event object containing event-specific data.
 * @param {Object} [props.category] - The current selected category.
 * @param {Array} [props.categories] - Optional; List of all categories to display as tabs. Defaults to event.question_categories.
 * @param {string} [props.allTabName] - Custom name for the 'all' tab.
 * @param {boolean} [props.hideMineTab=false] - Flag to hide the 'my' tab.
 * @param {function} [props.catLink] - Function to generate links for category tabs.
 */

function CategoriesTabs(props) {
    const { event, category, categories, allTabName, hideMineTab = false } = props,
        i18n = useI18n(),
        catLink =
            props.catLink ||
            ((catId) => {
                return ['/events', event.id, 'qa', catId].filter(Boolean).join('/');
            }),
        visibleCategories = (categories ?? event.question_categories)?.filter(isQuestionCategoryVisible) ?? [],
        showDefaultCategory = isQuestionCategoryVisible(event.default_question_category);

    const handleTabSelection = useCallback((catId, href) => {
        app.history.replace(href);
    }, []);

    let centerIndex = 0;
    if (category == 'mine') {
        centerIndex = visibleCategories.length + (showDefaultCategory ? 1 : 0);
    } else if (category && category.id) {
        centerIndex = visibleCategories.findIndex((cat) => cat.id == category.id) + (showDefaultCategory ? 1 : 0);
    }

    return (
        <Tabs visibleTabs={VISIBLE_TABS} arrows={visibleCategories.length + (showDefaultCategory ? 1 : 0 + (hideMineTab ? 0 : 1)) > VISIBLE_TABS} centerIndex={centerIndex}>
            {showDefaultCategory ? (
                <Tab selected={category == 'all'} onClick={handleTabSelection.bind(this, 'all', catLink())}>
                    {allTabName || i18n['label.all']}
                </Tab>
            ) : null}
            {visibleCategories.map((cat) => (
                <Tab selected={category && category.id == cat.id} onClick={handleTabSelection.bind(this, cat.id, catLink(cat.id))} key={cat.id}>
                    {cat.label}
                </Tab>
            ))}
            {hideMineTab ? null : (
                <Tab selected={category == 'mine'} onClick={handleTabSelection.bind(this, 'mine', catLink('mine'))}>
                    {i18n['label.my']}
                </Tab>
            )}
        </Tabs>
    );
}

export default CategoriesTabs;
